import React, { useEffect, useState } from "react";
import { Col, Row } from "react-bootstrap";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import Modal from "react-bootstrap/Modal";
import Calendar from "react-calendar";
import "react-calendar/dist/Calendar.css";
import "./selectDateTime.scss";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";

import ReactDatePicker from "react-datepicker";
import {
  getFullName,
  getUserTimeZoneOffset,
  twoDecimalPlaces,
} from "../../utils/common";
import moment from "moment";
import { setLoader } from "../../slice/commonSlice";
import {
  addCard,
  calculateTax,
  calculateTaxByAmount,
  fetchAuthorizeCustomerProfile,
  fetchProviderAvailability,
  verifyCoupons,
} from "../../services/auth.service";
import { MIN_CHARGEABLE_AMOUNT } from "../../config/Constant";
import * as cardValidator from "card-validator";
import { selectUser } from "../../slice/authSlice";
import { encryptData } from "../../utils/encryptDecrypt";
import { toast } from "react-toastify";
import authorizelogo from "../../assets/images/Authorize.net_logo.png";

const SelectDateTime = (props) => {
  const location = useLocation();
  const [chargesDetails, setChargesDetails] = useState(null);
  const [value, setValue] = useState(new Date());
  const [selectedTime, setSelectedTime] = useState(null);
  const [providerSlots, setProviderSlots] = useState([]);
  const [authorizeCustomerProfile, setAuthorizeCustomerProfile] = useState();
  const [cardNumber, setCardNumber] = useState("");
  const [cardMonth, setCardMonth] = useState("");
  const [cardYear, setCardYear] = useState("");
  const [cvv, setCvv] = useState();
  const [selectedCardId, setSelectedCardId] = useState(null);
  const dispatch = useDispatch();
  const user = useSelector(selectUser);
  const [errors, setErrors] = useState({
    cardNumber: "",
    cardYear: "",
    cardCvv: "",
  });

  const [couponCode, setCouponCode] = useState("");
  const [isCouponApplied, setIsCouponApplied] = useState(false);
  const [couponId, setCouponId] = useState(null);
  const [discountType, setDiscountType] = useState(null);
  const [couponDiscount, setCouponDiscount] = useState(null);
  const [couponError, setCouponError] = useState(false);
 const [isOpen, setIsOpen] = useState(false);
  const currentYear = new Date().getFullYear();
  const years = [];
  for (let i = currentYear; i <= currentYear + 21; i++) {
    years.push(i);
  }

  const [jobDescription, setJobDescription] = useState(""); // New state for job description
  const handleCardNumber = (value) => {
    value = value.replace(/\s/g, ""); // Remove existing spaces
    value = value.replace(/-/g, ""); // Remove existing dashes

    // Add space or dash after every four digits
    value = value.replace(/(\d{4})(?=\d)/g, "$1 ");

    // Trim extra characters if the length exceeds 19 digits (including spaces)
    value = value.slice(0, 23);
    setCardNumber(value);
  };

  const checkCard = () => {
    let valid = true;
    const cardNumberValidation = cardValidator.number(cardNumber);
    const expiryDateValidation = cardValidator.expirationDate({
      month: cardMonth,
      year: cardYear,
    });
    const cvvValidation = cardValidator.cvv(cvv);
    let newErros = { ...errors };
    if (!cardNumberValidation.isValid) {
      // alert('Invalid Card Number');
      valid = false;
      newErros.cardNumber = "Invalid card number";
      // return;
    } else {
      newErros.cardNumber = "";
    }

    if (!expiryDateValidation.isValid) {
      valid = false;
      newErros.cardYear = "Invalid card expiry date";
      // return;
    } else {
      newErros.cardYear = "";
    }

    if (!cvvValidation.isValid) {
      valid = false;
      newErros.cardCvv = "Invalid card number";
      // return;
    } else {
      newErros.cardCvv = "";
    }
    setErrors(newErros);
    return valid;
  };

  //get authorize customer profile
  const getAuthorizeCustomerProfile = async () => {
    let payload = {
      customerProfileId: user?.userCustomerProfileId,
    };
    await dispatch(setLoader(true));
    try {
      const response = await fetchAuthorizeCustomerProfile(payload);
      await dispatch(setLoader(false));
      if (response.status) {
        setAuthorizeCustomerProfile(response?.data);
        setSelectedCardId(
          response?.data.customerProfile.profile.paymentProfiles[0]
            .customerPaymentProfileId || null
        );
      }
    } catch (error) {
      await dispatch(setLoader(false));
      console.error("Error fetching data:", error);
    }
  };

  const handleAddCard = async () => {
    if (checkCard()) {
      const payload = {
        // cardName,
        cardExpirationDate: encryptData(cardMonth + cardYear),
        cvv: encryptData(cvv),
        customerProfileId: user.userCustomerProfileId,
        cardNumber: encryptData(cardNumber.replace(/\s/g, "")),
      };
      await dispatch(setLoader(true));
      try {
        const response = await addCard(payload);
        await dispatch(setLoader(false));
        setCardMonth("");
        setCardNumber("");
        setCardYear("");
        setSelectedCardId(null);
        setCvv("");
        getAuthorizeCustomerProfile();
        if (response?.data?.status) {
          toast.success(response.data.message, {
            position: toast.POSITION.TOP_CENTER,
          });
        } else {
          toast.error(response.data.message, {
            position: toast.POSITION.TOP_CENTER,
          });
        }
      } catch (error) {
        await dispatch(setLoader(false));
        console.error("Error fetching data:", error);
      }
    }
  };

  useEffect(() => {
    getAuthorizeCustomerProfile();
  }, []);

  // const handleTimeChange = (time) => {
  //   console.log(time,"selected time")
  //   // return
  //   // setSelectedTime(time);
  //   // props.setPickupTime(time);
  //   const currentTime = moment();
  //   const selectedDateTime = moment(time);

  //   // If the selected date is the current date
  //   if (value && moment(value).isSame(currentTime, "day")) {
  //     // Calculate the difference in minutes between current time and selected time
  //     const differenceInMinutes = selectedDateTime.diff(currentTime, "minutes");

  //     // Allow selection only if it's after 1 hour from the current time
  //     if (differenceInMinutes >= 60) {
  //       setSelectedTime(time);
  //       props.setPickupTime(time);
  //     } else {
  //       toast.error(
  //         "Please select a time after 1 hour from the current time.",
  //         {
  //           position: toast.POSITION.TOP_CENTER,
  //         }
  //       );
  //       setSelectedTime(null);
  //       return;
  //     }
  //   } else {
  //     // For future dates or if value is not set
  //     setSelectedTime(time);
  //     props.setPickupTime(time);
  //   }
  // };
  const handleTimeChange = (time) => {
    console.log(time, "selected time");

    // Directly set the selected time and send it to the parent component
    setSelectedTime(time);
    props.setPickupTime(time);
  };

  const handleClickHour = (hour) => {
    const selectedDate = moment(hour, "h:mm A").toDate(); // Convert hour string to Date object
    handleTimeChange(selectedDate);
  };

  const handleDateChange = (date) => {
    setValue(date);
    props.setPickupDay(date);
    providerAvailability(date);
  };

  const providerAvailability = async (date) => {
    // console.log("date", date);
    // console.log(
    //   "formatted",
    //   moment(date).startOf("day").format("YYYY-MM-DDTHH:mm:ss.SSS[Z]")
    // );

    let payload = {
      date: moment(date).startOf("day").format("YYYY-MM-DDTHH:mm:ss.SSS[Z]"),
      providerId: props.id,
      timezoneOffset: -180,
    };
    await dispatch(setLoader(true));
    try {
      const response = await fetchProviderAvailability(payload);
      await dispatch(setLoader(false));
      if (response.data?.status) {
        setProviderSlots(response?.data?.data);
      }
    } catch (error) {
      await dispatch(setLoader(false));
      console.error("Error fetching data:", error);
    }
  };
  useEffect(() => {
    const today = new Date();
    props.setPickupDay(today);
    providerAvailability(today);
  }, [props.id]);

  useEffect(() => {
    if (props.routeDetails?.durationInHour < 1) {
      calculateTaxPriceByAmount();
    } else {
      calculateTaxPriceByDuration();
    }
  }, [props.unitPrice, props.routeDetails?.durationInHour]);

  const calculateTaxPriceByDuration = async () => {
    let payload = {
      unitPrice: props.unitPrice,
      durationExpected: props.routeDetails?.durationInHour,
    };
    await dispatch(setLoader(true));
    try {
      const response = await calculateTax(payload);
      await dispatch(setLoader(false));
      if (response.status) {
        if (response.data?.charge < MIN_CHARGEABLE_AMOUNT) {
          calculateTaxPriceByAmount();
        } else {
          setChargesDetails(response.data);
        }
        //setChargesDetails(response.data)
      }
    } catch (error) {
      await dispatch(setLoader(false));
      console.error("Error fetching data:", error);
    }
  };
  const calculateTaxPriceByAmount = async () => {
    let payload = {
      amount: MIN_CHARGEABLE_AMOUNT,
    };
    await dispatch(setLoader(true));
    try {
      const response = await calculateTaxByAmount(payload);
      await dispatch(setLoader(false));
      if (response.status) {
        let amountDetails = {
          charge: MIN_CHARGEABLE_AMOUNT,
          taxAmount: response?.data?.taxAmount,
          //total: response?.data?.total
          total: response?.data?.finalAmount,
        };
        setChargesDetails(amountDetails);
      }
    } catch (error) {
      await dispatch(setLoader(false));
      console.error("Error fetching data:", error);
    }
  };

  const tileClassName = ({ date }) => {
    return date.toDateString() === value.toDateString()
      ? "react-calendar__tile--selected-date"
      : null;
  };

  const handleCouponCode = async () => {
    try {
      if (isOpen) {
      dispatch(setLoader(true));

      const payload = {
        serviceId: location.state?.serviceId,
        couponCode: couponCode,
        userId: user.id,
      };

      const response = await verifyCoupons(payload);
      console.log("responseresponse", response);

      if (response?.data?.success === true) {
        setIsCouponApplied(true);
        setCouponError(false);
        setCouponId(response?.data.discount.couponId);
        setDiscountType(response?.data.discount.discountType);
        setCouponDiscount(response?.data.discount.couponDiscount);
        toast.success("Coupon applied successfully!");
      } else {
        setIsCouponApplied(false);
        setCouponError(true);
      }
    }else{
      setIsOpen(true);
    }
    } catch (error) {
      console.log("error===========>",error)
      setIsCouponApplied(false);
      setCouponError(true);
    } finally {
      dispatch(setLoader(false));
    }
  };
  return (
    <>
      <Modal
        show={props.timeModal}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header
          className="z-3 position-relative"
          onClick={() => props.handleCloseTimeModal(false)}
          closeButton
        >
          <Modal.Title>Select Date & Time</Modal.Title>
        </Modal.Header>
        <Modal.Body className="z-1 position-relative">
          <div className="selectdatetime-wrapper">
            <Row className="g-5">
              <Col md={6}>
                {" "}
                <Calendar
                  minDate={new Date()}
                  tileClassName={tileClassName}
                  onChange={handleDateChange}
                  value={value}
                />
              </Col>
              <Col md={6}>
                <div className="parcel-pickup-time-wrap">
                  <Form.Label>Select Parcel Pickup Time</Form.Label>
                  <ReactDatePicker
                    className="form-control"
                    selected={selectedTime}
                    onChange={handleTimeChange}
                    showTimeSelect
                    showTimeSelectOnly
                    timeIntervals={15}
                    minDate={value}
                    dateFormat="h:mm aa"
                    timeCaption="Time"
                  />
                </div>
                <>
                  <div className="slots-wrapper">
                    <div className="available-slot-title">Available slots</div>

                    <div className="slots">
                      {Object.entries(providerSlots)
                        .filter(([hour, value]) => value === 1)
                        .map(([hour, value]) => (
                          <div
                            key={hour}
                            className={`hour active`}
                            onClick={() => handleClickHour(hour)}
                          >
                            {hour}
                          </div>
                        ))}
                    </div>
                  </div>
                </>
              </Col>
            </Row>
            <div className="payment-detail-wrap">
              {/* <table className="table">
                  <tr>
                    <td width="600">Total time</td>
                    <td width="140">
                      {twoDecimalPlaces(props.routeDetails?.durationInHour)} Hours
                    </td>
                  </tr>
                  <tr>
                    <td>Helpr app fee & Transaction fee</td>
                    <td>${twoDecimalPlaces(chargesDetails?.taxAmount)}</td>
                  </tr>
                  <tr>
                    <td>Subtotal</td>
                    <td>${twoDecimalPlaces(chargesDetails?.charge)}</td>
                  </tr>
                  <tr>
                    <td>Total</td>
                    <td>${twoDecimalPlaces(chargesDetails?.total)}</td>
                  </tr>
                </table> */}
              <table className="table">
                <tr>
                  <td width="600">Estimate Distance </td>
                  <td width="140">{props.routeDetails?.distance}</td>
                </tr>

                <tr>
                  <td width="600">Total time</td>
                  <td width="140">
                    {twoDecimalPlaces(props.routeDetails?.durationInMin)} min
                  </td>
                </tr>
              </table>
            </div>

            <div className="job-description-wrap mt-4">
              <Form.Label>Job Description</Form.Label>
              <Form.Control
                as="textarea"
                rows={3}
                value={jobDescription}
                placeholder="Enter job description"
                onChange={(e) => setJobDescription(e.target.value)}
              />
            </div>
            <div className="box-wrapper delivery-details-wrap">
              <div className="delivery-details">
                <div className="delivery-details-title">Pickup Details</div>
                <div className="delivery-user-name">
                  {getFullName(
                    props.senderDetails?.firstName,
                    props.senderDetails?.lastName
                  )}
                </div>
                <div className="delivery-user-address">
                  {props.senderDetails?.address}
                </div>
                <div className="delivery-user-phone">
                  {props.senderDetails?.phone}
                </div>
              </div>
              <div className="delivery-details-divider"></div>
              <div className="delivery-details">
                <div className="delivery-details-title">Delivery Details</div>

                <div className="delivery-user-name">
                  {getFullName(
                    props.receiverDetails?.firstName,
                    props.receiverDetails?.lastName
                  )}
                </div>
                <div className="delivery-user-address">
                  {props.receiverDetails?.address}
                </div>
                <div className="delivery-user-phone">
                  {props.receiverDetails?.phone}
                </div>
              </div>
            </div>
            <div className="account-info-wrap" id="manage-payment">
              <div className="account-info-title">
                Manage your payment methods
              </div>
              <div className="payment-method-wrapper">
                {authorizeCustomerProfile?.customerProfile?.profile
                  ?.paymentProfiles?.length ? (
                  authorizeCustomerProfile?.customerProfile?.profile?.paymentProfiles?.map(
                    (card, index) => (
                      <>
                        <div className="card-wrapper primary" key={index}>
                          <label htmlFor={`primary-${index}`}>
                            {/* <input
                          type="radio"
                          name="primary"
                          id={`primary-${index}`}
                        /> */}
                            <div className="card-left">
                              <label className="card-title">
                                Click to select card
                              </label>
                              <input
                                className="radioInput"
                                type="radio"
                                name="primary"
                                id={`primary-${index}`}
                                checked={
                                  selectedCardId ===
                                  card.customerPaymentProfileId
                                }
                                onChange={() =>
                                  setSelectedCardId(
                                    card.customerPaymentProfileId
                                  )
                                }
                              />
                            </div>
                            <div className="card-right">
                              <div className="card-number">
                                XXXX XXXX{" "}
                                {card?.payment?.creditCard?.cardNumber}
                              </div>
                              <div className="card-logo">
                                {card?.payment?.creditCard?.cardType}
                                {/* <MasterCardIcon /> */}
                              </div>
                            </div>
                          </label>
                        </div>
                        <div
                          className="add-new-card-row"
                          style={{ marginTop: "20px" }}
                        >
                          <div className="add-new-card"></div>
                        </div>
                      </>
                    )
                  )
                ) : (
                  <p>
                    You have not added any card yet, Please add card and select
                    card to proceed.
                  </p>
                )}

                <div className="add-new-card-form">
                  <div className="add-new-title">🔒Secure Payment</div>

                  <div className="add-new-title">Add New Card</div>
                  <div className="add-new-card w-100">
                    <Row className="g-3">
                      <Col md={12}>
                        <Form.Label>Card Number</Form.Label>
                        <Form.Control
                          type="text"
                          value={cardNumber}
                          placeholder="Enter Card Number"
                          onChange={(e) => handleCardNumber(e.target.value)}
                        />
                        <div className="payment-error">
                          {errors?.cardNumber ? errors.cardNumber : null}
                        </div>
                      </Col>
                      <Col md={4}>
                        <Form.Label>Expiry Month</Form.Label>
                        <Form.Select
                          aria-label="Default select example"
                          value={cardMonth}
                          onChange={(e) => setCardMonth(e.target.value)}
                        >
                          <option>Select Month</option>
                          <option value="01">01</option>
                          <option value="02">02</option>
                          <option value="03">03</option>
                          <option value="04">04</option>
                          <option value="05">05</option>
                          <option value="06">06</option>
                          <option value="07">07</option>
                          <option value="08">08</option>
                          <option value="09">09</option>
                          <option value="10">10</option>
                          <option value="11">11</option>
                          <option value="12">12</option>
                        </Form.Select>
                      </Col>
                      <Col md={4}>
                        <Form.Label>Expiry Year</Form.Label>
                        <Form.Select
                          value={cardYear}
                          onChange={(e) => setCardYear(e.target.value)}
                          aria-label="Select Expiry Year"
                        >
                          <option value="">Select Year</option>
                          {years.map((year) => (
                            <option key={year} value={year}>
                              {year}
                            </option>
                          ))}
                        </Form.Select>
                        <div className="payment-error">
                          {errors?.cardYear ? errors.cardYear : null}
                        </div>
                      </Col>
                      <Col md={4}>
                        <Form.Label>CVV</Form.Label>
                        <Form.Control
                          type="text"
                          value={cvv}
                          placeholder="Enter CVV"
                          onChange={(e) => setCvv(e.target.value)}
                        />
                        <div className="payment-error">
                          {errors?.cardCvv ? errors.cardCvv : null}
                        </div>
                      </Col>
                    </Row>
                    <div className="d-flex justify-content-between mt-3 align-items-center">
                      <Button
                        variant="primary"
                        onClick={handleAddCard}
                        style={{ marginBottom: "20px" }}
                      >
                        Add Card
                      </Button>
                    </div>
                    <div className="secured-payment d-flex justify-content-end align-items-center">
                      <span style={{ fontSize: "14px" }}>Powered By :</span>
                    </div>
                    <div className="secured-payment d-flex justify-content-end align-items-center">
                      <img
                        src={authorizelogo}
                        alt="Authorize Logo"
                        style={{ width: "100px", height: "auto" }}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
             {isOpen && (
            <div className="w-50 mx-auto">
              <Form.Label className="text-center w-100 danger">
                {isCouponApplied
                  ? "Code applied!"
                  : couponError
                  ? "Looks like that did not work!"
                  : "Enter a voucher code"}
              </Form.Label>

              <Form.Control
                type="text"
                value={couponCode.toUpperCase()}
                placeholder="Enter a voucher code"
                onChange={(e) => setCouponCode(e.target.value)}
                disabled={isCouponApplied}
              />
            </div>
                )}

            <div className="selectdatetime-footer w-100 d-flex justify-content-center">
              <Button
                variant="primary"
                onClick={handleCouponCode}
                disabled={isCouponApplied}
                className="text-center"
              >
                Apply a voucher code
              </Button>
            </div>
            <div className="selectdatetime-footer w-100 d-flex justify-content-center">
              <Button
                variant="primary"
                disabled={!selectedTime || !selectedCardId}
                onClick={() =>
                  props.handleCloseTimeModal(
                    true,
                    selectedCardId,
                    jobDescription,
                    couponId,
                    discountType,
                    couponDiscount,
                    couponCode
                  )
                }
              >
                Confirm Booking
              </Button>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default SelectDateTime;
